<template>
  <div
    v-if="captionBrand || captionItem"
    class="mt-5 leading-none text-3-mob lg:text-3-desk"
  >
    <span class="italic">{{ captionBrand }}</span>
    <span v-show="captionBrand && captionItem" class="italic">: </span>
    <span class="small-caps">{{ captionItem.toLowerCase() }}</span>
  </div>
</template>

<script>
export default {
  name: "ContentCaption",

  props: {
    captionBrand: {
      type: String,
      default: ""
    },
    captionItem: {
      type: String,
      default: ""
    }
  }
};
</script>
